import React, { useState } from "react";

// Image that gracefully falls back if the original CDN blocks hotlinking
export default function SmartImage({ src, fallback, alt, className = "", ...rest }) {
  const [current, setCurrent] = useState(src);
  const [loaded, setLoaded] = useState(false);

  return (
    <img
      src={current}
      alt={alt}
      loading="lazy"
      onLoad={() => setLoaded(true)}
      onError={() => {
        if (fallback && current !== fallback) setCurrent(fallback);
      }}
      className={`${className} ${loaded ? "opacity-100" : "opacity-0"}`}
      style={{ transition: "opacity .6s ease" }}
      {...rest}
    />
  );
}
